import { makeAutoObservable, toJS } from 'mobx'

import { SearchToursApi, SpecialTourByCategory } from 'shared/api/tours/search'

class SpecialTourStore {
  specialTourList: SpecialTourByCategory[] | [] = []
  isLoading: boolean = false
  abortController: AbortController | null = null

  constructor() {
    makeAutoObservable(this)
  }

  async requestSpecialToursList() {
    try {
      this.isLoading = true

      const { data: toursData } = await SearchToursApi.getSpecialTours()

      this.specialTourList = toursData?.data || []
    } finally {
      this.isLoading = false
    }
  }

  getSpecialTourList() {
    return toJS(this.specialTourList)
  }
}

export default new SpecialTourStore()
